function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M18 12.9h-.68l-2 1.8h1.91L19 16.5H5l1.78-1.8h2.05l-2-1.8H6l-3 2.7v3.6c0 .99.89 1.8 1.99 1.8H19c1.1 0 2-.8 2-1.8v-3.6l-3-2.7zm-1-4.544l-4.95 4.454-3.54-3.185 4.95-4.455L17 8.356zm-4.24-5.094L6.39 8.995a.834.834 0 000 1.269l4.95 4.454c.39.351 1.02.351 1.41 0l6.36-5.723a.834.834 0 000-1.27l-4.95-4.454c-.38-.36-1.01-.36-1.4-.009z",
  fill: "#fff"
});

function SvgProposals(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref);
}

export default SvgProposals;